import { useDispatch } from "react-redux";

import {
  getListData,
  clearListState,
  payloadAgentsList,
  getBrandsListData,
  clearBrandsListState,
  getWalletsData,
  clearWalletsState,
  createWalletsData,
  clearCreateWalletsState,
  getDescendantAgentsData,
  clearDescendantAgentsState,
  payloadDescendantAgents,
  getAgentRolesData,
  clearAgentRolesState,
  getWalletIdentitiesData,
  clearWalletIdentitiesState,
  payloadWalletIdentities,
  createAgentData,
  clearCreateAgentState,
  getDetailsListData,
  clearDetailsState,
  enableWalletData,
  clearEnableWalletState,
  disableWalletData,
  clearDisableWalletState,
  addWalletsData,
  addAgentWalletData,
  clearAddWalletState,
  getAgentBalanceByIdData,
  clearAgentBalanceState,
  getAgentNetworkBalanceByIdData,
  clearAgentNetworkBalanceState,
  getPlayerListData,
  clearPlayerListState,
  getPlayerBalanceByIdData,
  clearPlayerBalanceState,
  getPlayerListDetailsData,
  clearPlayerListDetailsState,
  payloadPlayersList,
  transferToAgentData,
  clearTransferToAgentState,
  getPlayersOptionsData,
  clearPlayersOptionsState,
  payloadPlayersOptions,
  getPlayerWalletIdentitiesData,
  clearPlayerWalletIdentitiesState,
  payloadPlayerWalletIdentities,
  transferToPlayerData,
  clearTransferToPlayerState,
  getFullListData,
  clearFullListState,
  getFullDetailsListData,
  clearFullDetailsState,
  getFullAgentsOptionData,
  clearFullAgentsOptionsState,
  getFullTrAgentsOptionData,
  clearFullTrAgentsOptionsState,
  transferAllToAgentData,
  clearTransferAllToAgentState,
  getFullPlayerListData,
  clearFullPlayerListState,
  getFullPlayerListDetailsData,
  clearFullPlayerListDetailsState,
  getAgentProfileData,
  clearAgentProfileState,
  payloadAgentProfile,
  payloadUpdateAgentProfile,
  updateAgentProfileData,
  clearUpdateAgentProfileState,
  getPlayerProfileData,
  clearPlayerProfileState,
  getExternalPlayerProfileData,
  clearExternalPlayerProfileState,
  payloadPlayerProfile,
  clearAgentRoleState,
  updateAgentRoleData,
  payloadUpdateAgentRole,
  getFilterRolesData,
  getFilterRolesAllData,
  toggleBlockAgentData,
  clearToggleBlockAgentState,
  setAgentNewPasswordData,
  clearAgentNewPasswordState,
  getBetListFiltersData,
  getCasinoBetListFiltersData,
  clearPlayerStatusState,
  clearToggleBlockPlayerState,
  getPlayerStatusData,
  toggleBlockPlayerData,
  setPlayerNewPasswordData,
  clearPlayerNewPasswordState,
  createPlayerData,
  clearCreatePlayerState,
  getToDescendantAgentsData,
  clearToDescendantAgentsState,
  clearAddAgentWalletState,
  PayloadAddAgentWalletType,
} from "./index";

export const useAgents = () => {
  const dispatch = useDispatch();

  const getList = (data: payloadAgentsList) => dispatch(getListData(data));
  const clearList = () => dispatch(clearListState());
  const getFullList = (data: payloadAgentsList) => dispatch(getFullListData(data));
  const clearFullList = () => dispatch(clearFullListState());
  const getDetails = (data: payloadAgentsList) => dispatch(getDetailsListData(data));
  const clearDetails = () => dispatch(clearDetailsState());

  const getFullDetails = (data: payloadAgentsList) => dispatch(getFullDetailsListData(data));
  const clearFullDetails = () => dispatch(clearFullDetailsState());

  const getBrandsList = (data: any) => dispatch(getBrandsListData(data));
  const clearBrandsList = () => dispatch(clearBrandsListState());

  const getWallets = () => dispatch(getWalletsData());
  const clearWallets = () => dispatch(clearWalletsState());

  const createWallets = (data: any) => dispatch(createWalletsData(data));
  const clearCreateWallets = () => dispatch(clearCreateWalletsState());

  const getDescendantAgents = (data: payloadDescendantAgents) => dispatch(getDescendantAgentsData(data));
  const clearDescendantAgents = () => dispatch(clearDescendantAgentsState());

  const getToDescendantAgents = (data: payloadDescendantAgents) => dispatch(getToDescendantAgentsData(data));
  const clearToDescendantAgents = () => dispatch(clearToDescendantAgentsState());

  const getAgentRoles = () => dispatch(getAgentRolesData());
  const clearAgentRoles = () => dispatch(clearAgentRolesState());

  const getWalletIdentities = (data: payloadWalletIdentities)=> dispatch(getWalletIdentitiesData(data));
  const clearWalletIdentities = () => dispatch(clearWalletIdentitiesState());

  const createAgent = (data: any)=> dispatch(createAgentData(data));
  const clearCreateAgent = () => dispatch(clearCreateAgentState());

  const enableWallet = (data: any)=> dispatch(enableWalletData(data));
  const clearEnableWallet = () => dispatch(clearEnableWalletState());

  const disableWallet = (data: any)=> dispatch(disableWalletData(data));
  const clearDisableWallet = () => dispatch(clearDisableWalletState());

  const addWallets = (data: any)=> dispatch(addWalletsData(data));
  const clearAddWallet = () => dispatch(clearAddWalletState());

  const addAgentWallet = (data: PayloadAddAgentWalletType)=> dispatch(addAgentWalletData(data));
  const clearAddAgentWallet = () => dispatch(clearAddAgentWalletState());

  const getAgentBalanceById = (data: any)=> dispatch(getAgentBalanceByIdData(data));
  const clearAgentBalance = () => dispatch(clearAgentBalanceState());

  const getAgentNetworkBalanceById = (data: any)=> dispatch(getAgentNetworkBalanceByIdData(data));
  const clearAgentNetworkBalance = () => dispatch(clearAgentNetworkBalanceState());

  const getPlayerList = (data: payloadPlayersList) => dispatch(getPlayerListData(data));
  const clearPlayerList = () => dispatch(clearPlayerListState());

  const getFullPlayerList = (data: payloadPlayersList) => dispatch(getFullPlayerListData(data));
  const clearFullPlayerList = () => dispatch(clearFullPlayerListState());

  const getPlayerBalanceById = (data: any)=> dispatch(getPlayerBalanceByIdData(data));
  const clearPlayerBalance = () => dispatch(clearPlayerBalanceState());

  const getPlayerListDetails = (data: payloadPlayersList) => dispatch(getPlayerListDetailsData(data));
  const clearPlayerListDetails = () => dispatch(clearPlayerListDetailsState());

  const transferToAgent = (data: any) => dispatch(transferToAgentData(data));
  const clearTransferToAgent = () => dispatch(clearTransferToAgentState());

  const getPlayersOptions = (data: payloadPlayersOptions) => dispatch(getPlayersOptionsData(data));
  const clearPlayersOptions = () => dispatch(clearPlayersOptionsState());

  const getPlayerWalletIdentities = (data: payloadPlayerWalletIdentities)=> dispatch(getPlayerWalletIdentitiesData(data));
  const clearPlayerWalletIdentities = () => dispatch(clearPlayerWalletIdentitiesState());

  const transferToPlayer = (data: any) => dispatch(transferToPlayerData(data));
  const clearTransferToPlayer = () => dispatch(clearTransferToPlayerState());

  const getFullAgentsOption = (data: payloadDescendantAgents) => dispatch(getFullAgentsOptionData(data));
  const clearFullAgentsOptions = () => dispatch(clearFullAgentsOptionsState());

  const getFullTrAgentsOption = (data: payloadDescendantAgents) => dispatch(getFullTrAgentsOptionData(data));
  const clearFullTrAgentsOptions = () => dispatch(clearFullTrAgentsOptionsState());

  const transferAllToAgent = (data: any) => dispatch(transferAllToAgentData(data));
  const clearTransferAllToAgent = () => dispatch(clearTransferAllToAgentState());

  const getFullPlayerListDetails = (data: payloadPlayersList) => dispatch(getFullPlayerListDetailsData(data));
  const clearFullPlayerListDetails = () => dispatch(clearFullPlayerListDetailsState());


  const getAgentProfile = (data: payloadAgentProfile) => dispatch(getAgentProfileData(data));
  const clearAgentProfile = () => dispatch(clearAgentProfileState());

  const updateAgentProfile = (data: payloadUpdateAgentProfile) => dispatch(updateAgentProfileData(data));
  const clearUpdateAgentProfile = () => dispatch(clearUpdateAgentProfileState());

  const getPlayerProfile = (data: payloadPlayerProfile) => dispatch(getPlayerProfileData(data));
  const clearPlayerProfile = () => dispatch(clearPlayerProfileState());

  const getExternalPlayerProfile = (data: payloadPlayerProfile) => dispatch(getExternalPlayerProfileData(data));
  const clearExternalPlayerProfile = () => dispatch(clearExternalPlayerProfileState());

  const updateAgentRole = (data: payloadUpdateAgentRole) => dispatch(updateAgentRoleData(data));
  const clearUpdateAgentRole = () => dispatch(clearAgentRoleState());

  const getFilterRoles = () => dispatch(getFilterRolesData());
  const getFilterRolesAll = () => dispatch(getFilterRolesAllData());

  const toggleBlockAgent = (data:any) => dispatch(toggleBlockAgentData(data));
  const clearToggleBlockAgent = () => dispatch(clearToggleBlockAgentState());

  const setAgentNewPassword = (data: any) => dispatch(setAgentNewPasswordData(data));
  const clearAgentNewPassword = () => dispatch(clearAgentNewPasswordState());

  const getBetListFilters = () => dispatch(getBetListFiltersData());
  const getCasinoBetListFilters = () => dispatch(getCasinoBetListFiltersData());

  const toggleBlockPlayer = (data:any) => dispatch(toggleBlockPlayerData(data));
  const clearToggleBlockPlayer = () => dispatch(clearToggleBlockPlayerState());

  const getPlayerStatus = (data:any) => dispatch(getPlayerStatusData(data));
  const clearPlayerStatus = () => dispatch(clearPlayerStatusState());

  const setPlayerNewPassword = (data: any) => dispatch(setPlayerNewPasswordData(data));
  const clearPlayerNewPassword = () => dispatch(clearPlayerNewPasswordState());

  const createPlayer = (data: any)=> dispatch(createPlayerData(data));
  const clearCreatePlayer = () => dispatch(clearCreatePlayerState());

  return {
    getList,
    clearList,
    getFullList,
    clearFullList,
    getBrandsList,
    clearBrandsList,
    getWallets,
    clearWallets,
    createWallets,
    clearCreateWallets,
    getDescendantAgents,
    clearDescendantAgents,
    getAgentRoles,
    clearAgentRoles,
    getWalletIdentities,
    clearWalletIdentities,
    createAgent,
    clearCreateAgent,
    getDetails,
    clearDetails,
    enableWallet,
    clearEnableWallet,
    disableWallet,
    clearDisableWallet,
    addWallets,
    clearAddWallet,
    addAgentWallet,
    clearAddAgentWallet,
    getAgentBalanceById,
    clearAgentBalance,
    getAgentNetworkBalanceById,
    clearAgentNetworkBalance,
    getPlayerList,
    clearPlayerList,
    getPlayerBalanceById,
    clearPlayerBalance,
    getPlayerListDetails,
    clearPlayerListDetails,
    transferToAgent,
    clearTransferToAgent,
    getPlayersOptions,
    clearPlayersOptions,
    getPlayerWalletIdentities,
    clearPlayerWalletIdentities,
    transferToPlayer,
    clearTransferToPlayer,
    getFullDetails,
    clearFullDetails,
    getFullAgentsOption,
    clearFullAgentsOptions,
    transferAllToAgent,
    clearTransferAllToAgent,
    getFullTrAgentsOption,
    clearFullTrAgentsOptions,
    getFullPlayerList,
    clearFullPlayerList,
    getFullPlayerListDetails,
    clearFullPlayerListDetails,
    getAgentProfile,
    clearAgentProfile,
    updateAgentProfile,
    clearUpdateAgentProfile,
    getPlayerProfile,
    clearPlayerProfile,
    getExternalPlayerProfile,
    clearExternalPlayerProfile,
    updateAgentRole,
    clearUpdateAgentRole,
    getFilterRoles,
    getFilterRolesAll,
    toggleBlockAgent,
    clearToggleBlockAgent,
    setAgentNewPassword,
    clearAgentNewPassword,
    getBetListFilters,
    getCasinoBetListFilters,
    toggleBlockPlayer,
    clearToggleBlockPlayer,
    getPlayerStatus,
    clearPlayerStatus,
    setPlayerNewPassword,
    clearPlayerNewPassword,
    createPlayer,
    clearCreatePlayer,
    getToDescendantAgents,
    clearToDescendantAgents,
  }
}
